// extracted by mini-css-extract-plugin
module.exports = {"container":"Xj9p94i6rAo_8S929zL1i","space":"_3DxxdEn0W_15BMaJOr5gOa","number":"sPoTRNbsqWo3cO4yTY8xE","subText":"_1IUSqqAJ-iBR83KYX-SNhi"};